const imageTypeFilter = ['image/jpeg', 'image/png', 'image/gif'];

export default imageTypeFilter;
